jQuery(document).ready(function(){
    /* remove duplicate title in product page for older product */
    var $h3 = $(".product-single__description h3:first-child");
    var $h2 = $(".product-single__description h2:first-child");
    var $h1 = $(".product-single__description h1:first-child");
    var h3_text = $h3.text().trim().toLowerCase();
    var h2_text = $h2.text().trim().toLowerCase();
    var h1_text = $h2.text().trim().toLowerCase();
    var product_title = $(".product-single__title").text().trim().toLowerCase();
    if(h3_text.indexOf(product_title) != -1 || product_title.indexOf(h3_text) != -1){
        $h3.remove();
    }
    if(h2_text.indexOf(product_title) != -1 || product_title.indexOf(h2_text) != -1){
        $h2.remove();
    }
    if(h1_text.indexOf(product_title) != -1 || product_title.indexOf(h1_text) != -1){
        $h1.remove();
    }
    /* END remove duplicate title in product page for older product */

    /* Site Translation */
    var pm_translations = [["Apprendre l'anglais",'Learning English'],['numérique','digital'],['anglais','english'],['mois','month'],['solde', 'sale'],['ans', 'years'],['ans et +', 'years & +'],['Montessori','Montessori'],['Lecture et écriture','Reading and writing'],['Mathématique','Mathematical'],['Sciences et Découvertes','Sciences and Discoveries'],['Histoire et Géographie','History and Geography'],['Nature et Animaux','Nature and Animals'],['Motricité fine et Tri','Fine motor skills and sorting'],['Couleurs et Formes','Colors and Shapes'],['Mémoire et Observation','Memory and Observation'],['Ouverture sur le monde','Window to the world'],['Émotions','Emotions'],['Habiletés sociales','Social skills'],['Éveil artistique','Artistic awakening']];

    function site_translation(){
        if(Shopify.locale == "en"){
            $('li.tag a, .collapsible-content__inner span.p-info').each(function() {
                var $context = $(this);
                var text = $context.text();
                for(var i = 0; i < pm_translations.length; i++) {
                    if(text.indexOf(pm_translations[i][0]) !== -1){
                        $context.text(text.replace(pm_translations[i][0], pm_translations[i][1]));
                        break;
                    }
                }
            });
        }
        $(".sdd-download-button").text("Télécharger / Download");
    }  

    $("body").on('click', "li.tag", function() {
        setTimeout(function(){
            site_translation();
        },600);
    });

    if(Shopify.locale != "fr"){
        site_translation();
    }

    //scroll to form on success
    if (window.location.href.indexOf("contact_posted=true") > -1) {
        setTimeout(function(){
            var elmnt = document.getElementById("form-anchor");
            elmnt.scrollIntoView({ behavior: 'instant', block: 'center' });
        },400);
    }


});


function update_product_to_cart(cartUpdates) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartUpdates),
    })
    .then(response => {
        if (response.ok) {
            let eventData = { once: true };
            localStorage.setItem("can_fee_added_once", "true");
            document.dispatchEvent(new CustomEvent('cart:build', { detail: eventData }));
            return response.json();
        } else {
            throw new Error('Request failed');
        }
    })
    .then(data => {
        // Handle the response data here
        //console.log(data);
        // Get the current URL
        var currentURL = window.location.href;
        var queryString = window.location.search;

        // Check if the URL contains "/cart"
        if (currentURL.includes("/cart") && !queryString.includes("?reload=1")) {
            // If it contains "/cart", redirect to "/cart?reload=1"
            window.location.href = "/cart?reload=1";
        }

    })
    .catch(error => {
        // Handle errors here
        console.error(error);
    });
}

function add_product_to_cart(items) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", '/cart/add.json', false);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                var data = JSON.parse(xhr.responseText);
                //document.dispatchEvent(new CustomEvent('cart:build'));
            } else {
                var obj = JSON.parse(xhr.responseText);
                alert(obj.errors);
            }
        }
    };

    var jsonData = JSON.stringify({ items: items });
    xhr.send(jsonData);
}

const falsyToZero = (value) => {
    return (value === null || isNaN(value) || value === false) ? 0 : value;
}


async function getShopifyCart() {
    try {
      const response = await fetch('/cart.js'); // Replace with your Shopify cart endpoint
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      return cartData.items;
    } catch (error) {
      throw new Error(`Error getting the cart: ${error.message}`);
    }
}
  
  async function removeItemsFromCartAndRefresh(cart, the_can_fees) {
    const feeAddonProducts = new Set(the_can_fees.map((fee) => fee.fee_addon_product));
    const itemsToRemove = cart.filter((item) =>
      feeAddonProducts.has(item.variant_id.toString())
    );
  
    if (itemsToRemove.length === 0) {
      // No items to remove, no need to make the AJAX call
      return cart;
    }
  
    const itemIdsToRemove = itemsToRemove.map((item) => item.id);
  
    const updateData = {
      updates: {},
    };
  
    itemIdsToRemove.forEach((itemId) => {
      updateData.updates[itemId] = 0; // Set the quantity to 0 to remove items
    });
  
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const cartData = await response.json();
      return cartData.items;
    } catch (error) {
      throw new Error(`Error updating the cart: ${error.message}`);
    }
  }
  
  
  async function updateCartAsync(evt, can_fees, customer_province) {
    var myitems = [];
    var isPresent = false;
    var cartUpdates = {
      updates: {},
    };
  
    for (var product of evt.detail.cart.items) {
      var variantId = product.variant_id;
      var quantity = product.quantity;
  
      isPresent = false;
      for (var i = 0; i < can_fees.length; i++) {
        var item = can_fees[i];
        //console.log(variantId, item.products.includes(variantId));
        if (item.products.includes(variantId) && customer_province == can_fees[i].province) {
          isPresent = true;
          cartUpdates.updates[can_fees[i].fee_addon_product] = falsyToZero(cartUpdates.updates[can_fees[i].fee_addon_product]) + parseInt(quantity);
          myitems.push({
            quantity: quantity,
            id: can_fees[i].fee_addon_product,
          });
        }
      }
    }
  
    update_product_to_cart(cartUpdates);
  
    // Use 'await' to perform asynchronous operations here if needed
    // For example, you can make an AJAX call to update the cart
  
    // Return the relevant data as needed
    return {
      myitems,
      cartUpdates,
    };
  }
  



addEventListener("DOMContentLoaded", (event) => {


    document.addEventListener('cart:updated', function(evt) {
 
        if(localStorage.getItem("can_fee_added_once") == "true"){
            localStorage.setItem("can_fee_added_once", "");
            return;
        }
        (async () => {
            try {
              // Get the cart from Shopify
              const currentCart = await getShopifyCart();


              console.log("hiya");
             console.log(currentCart); 
             console.log("hiya2");
             console.log(JSON.stringify(evt.detail.cart.items) === JSON.stringify(currentCart) );
              // Call the function to remove items and refresh the cart
              const removedCart = await removeItemsFromCartAndRefresh(currentCart, can_fees);


            // Assuming you have 'evt', 'can_fees', and 'customer_province' defined
            const updatedCart = await updateCartAsync(evt, can_fees, customer_province);
          
              // Handle the updated cart data here
              //console.log(removedCart,updatedCart);
            } catch (error) {
              console.error(error);
            }
          })();
/*
        var myitems = [];
        var isPresent = false;
        var cartUpdates = {
            updates: {
            }
        };
        
        for (var product of evt.detail.cart.items) {
            var variantId = product.variant_id;
            var quantity = product.quantity;

            isPresent = false;
            for (var i = 0; i < can_fees.length; i++) {
                var item = can_fees[i];
                console.log(variantId,item.products.includes(variantId))
                if (item.products.includes(variantId) && customer_province == can_fees[i].province) {
                    isPresent = true;
                    cartUpdates.updates[can_fees[i].fee_addon_product] = falsyToZero(cartUpdates.updates[can_fees[i].fee_addon_product]) + parseInt(quantity); 
                    myitems.push({
                        quantity: quantity,
                        id: can_fees[i].fee_addon_product
                    });
                    
                }
            }

        }*/

        /*
        if(!isPresent){
            can_fees.forEach(function(data) {
            var variantIdToRemove = data.fee_addon_product;

            // Create a new XMLHttpRequest
            var xhr = new XMLHttpRequest();
            
            // Define the request method and URL
            xhr.open('POST', '/cart/change.js', true);
            
            // Set the request headers
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
            
            // Define the request body
            var requestBody = 'quantity=0&id=' + encodeURIComponent(variantIdToRemove);
            
            // Define the success and error handlers
            xhr.onload = function() {
                if (xhr.status === 200) {
                console.log('Removed variant with ID ' + variantIdToRemove + ' from the cart.');
                } else {
                console.error('Failed to remove variant with ID ' + variantIdToRemove + ' from the cart.');
                }
            };
            
            xhr.onerror = function() {
                console.error('Network error occurred.');
            };
            
            // Send the request
            xhr.send(requestBody);

            });
        }*/

        //update_product_to_cart(cartUpdates);


      });



    document.addEventListener('ajaxProduct:added', function(evt) {
        return;
        var current_vID = evt.detail.product.variant_id;
        console.log(evt);
        var isPresent = false;
        for (var i = 0; i < can_fees.length; i++) {
            var item = can_fees[i];
            console.log(item);
            if (item.products.includes(current_vID) && customer_province == can_fees[i].province) {
                isPresent = true;

                var myitems = [
                    {
                        quantity: evt.detail.product.single_quantity,
                        id: can_fees[i].fee_addon_product
                    }
                ];
                
                add_product_to_cart(myitems);
                break;
            }
        }
    });
});